import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { createQueryKeys, queryKeys } from "@nasam/kernel";
import type {
  AssetAssignInput,
  AssetAssignmentsListQuery,
  AssetAssignmentsRepository,
} from "../domain";

const assetAssignmentsQueryKeys = createQueryKeys("fleet-asset-assignments");

export function useAssetAssignmentsQuery(
  repository: AssetAssignmentsRepository,
  query?: AssetAssignmentsListQuery,
) {
  return useQuery({
    queryKey: assetAssignmentsQueryKeys.list(
      query === undefined ? undefined : { ...query },
    ),
    queryFn: () => repository.list(query),
  });
}

export function useAssignAssetsMutation(repository: AssetAssignmentsRepository) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (input: AssetAssignInput) => repository.assign(input),
    // A rejection throws and never reaches here, so success always means
    // every asset moved. The assets themselves changed branch too, so the
    // Asset Management screens and the asset picker refetch.
    onSuccess: () =>
      Promise.all([
        client.invalidateQueries({ queryKey: assetAssignmentsQueryKeys.all }),
        client.invalidateQueries({ queryKey: queryKeys.assets.all }),
      ]),
  });
}
